export default __webpack_public_path__ + "static/media/zoom-out.b298b9db.svg";